"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AccordionSummary.default;
  }
});

var _AccordionSummary = _interopRequireDefault(require("./AccordionSummary"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/AccordionSummary/index.js
// module id = 362
// module chunks = 0